export default {
  Home: "首页",
  Conversation: "对话管理",
  Config: "配置管理",
  Service: "客服管理",
  Label: "标签管理",
  System: "系统管理",
  Users: "用户管理",
  Menus: "菜单管理",
  SystemDept: "部门管理",
  Roles: "角色管理",
  Report: "报告",
  PersonalCenter: "个人中心",
  QuickReply: "快捷回复",
  statement: "召回统计",
  Task: "任务管理",
  TaskList: "任务列表",
  TaskConfig: "任务配置",
};
